import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Colors } from "../../constants/colors";
/**
 * Tooltip component that displays on hover
 * Appears above the trigger element with a small arrow
 */
export const Tooltip = ({ text, children }) => {
    const [isVisible, setIsVisible] = React.useState(false);
    // Clone the child element and add hover handlers
    const trigger = React.cloneElement(children, {
        onMouseEnter: (e) => {
            setIsVisible(true);
            // Call original onMouseEnter if it exists
            if (children.props.onMouseEnter) {
                children.props.onMouseEnter(e);
            }
        },
        onMouseLeave: (e) => {
            setIsVisible(false);
            // Call original onMouseLeave if it exists
            if (children.props.onMouseLeave) {
                children.props.onMouseLeave(e);
            }
        },
    });
    return (_jsxs("div", { className: "relative inline-flex", children: [trigger, isVisible && (_jsxs("div", { className: "absolute top-full left-1/2 -translate-x-1/2 mt-2 flex flex-col items-center pointer-events-none z-50", children: [_jsx("svg", { width: "16", height: "8", viewBox: "0 0 16 8", fill: "none", className: "-mb-px", children: _jsx("path", { d: "M8 0L16 8H0L8 0Z", fill: Colors.Gray900 }) }), _jsx("div", { className: "px-2 py-0.5 rounded-lg whitespace-nowrap", style: {
                            backgroundColor: Colors.Gray900,
                            boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.06), 0px 0px 2px 0px rgba(0,0,0,0.06), 0px 0px 1px 0px rgba(0,0,0,0.04)',
                        }, children: _jsx("p", { className: "font-sans font-normal leading-normal text-[13px] text-white m-0", children: text }) })] }))] }));
};
